/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllProductionQaChecksFromPreviousOrder } from '../../models/all-production-qa-checks-from-previous-order';

export interface GetAllQaChecksFromPreviousOrders$Params {
  productionOrderId: number;
}

export function getAllQaChecksFromPreviousOrders(http: HttpClient, rootUrl: string, params: GetAllQaChecksFromPreviousOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<AllProductionQaChecksFromPreviousOrder>> {
  const rb = new RequestBuilder(rootUrl, getAllQaChecksFromPreviousOrders.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AllProductionQaChecksFromPreviousOrder>;
    })
  );
}

getAllQaChecksFromPreviousOrders.PATH = '/api/v1/QaCheck/{productionOrderId}/GetAllQaChecksFromPreviousOrders';
